{
  "id": "campaign-017",
  "name": "Merry Run",
  "seed": "campaign:17",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".........HHH",
    ".........HHH",
    ".........___",
    "............",
    ".T..T..T..T.",
    "....,.......",
    "...,,,......",
    "....,.......",
    "....B.~B....",
    ".....~~~....",
    "......~.....",
    "............",
    "............",
    ".......x....",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 12
    }
  ],
  "generatorVersion": 3,
  "level": 17,
  "biome": "backyard",
  "par": {
    "reel": 5690,
    "push": 4767,
    "selfPropelled": 4398,
    "tractor": 4105,
    "zeroTurn": 3086,
    "fairway": 1899
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
